import { Box, Button, Typography, Grid } from '@mui/material';
import { styled } from '@mui/system';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { NEW_REQUEST } from '../../constants/Constants';
import { getBusinessUnit } from '../../store/APISlice';
import UserProfile from '../userProfile/UserProfile';
import { useAppDispatch } from '../../store/store';
import { clearFormData } from '../../store/formSlice';

const StyledButton = styled(Button)({
  backgroundColor: '#ffffff',
  color: '#0047ba',
  border: 'none',
  padding: '10px 40px',
  borderRadius: '5px',
  cursor: 'pointer',
  fontSize: '14px',
  margin: '0 10px',
  fontWeight: '600',
  transition: 'background-color 0.3s',
  '&:hover': {
    backgroundColor: '#ffffff',
  },
});

// const HomeChip = styled(Chip)({
//   backgroundColor: 'white',
//   color: '#007bff',
//   padding: '10px 15px',
//   borderRadius: '25px',
//   textDecoration: 'none',
//   marginTop: '20px',
//   boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
//   transition: 'background-color 0.3s, transform 0.3s',
//   '&:hover': {
//     backgroundColor: '#e0e0e0',
//     transform: 'scale(1.05)',
//   },
// });

const InboundAutomation = () => {
  const navigate = useNavigate();
  const selectedBu = useSelector(getBusinessUnit);
  const resetFormRef = useRef<() => void>(null);
  const dispatch = useAppDispatch();
  const createNewRequest = () => {
    dispatch(clearFormData());
    if (resetFormRef.current) {
      resetFormRef.current(); // Reset the form values
    }
    navigate(NEW_REQUEST);
    // Add functionality here
  };

  const duplicateRequest = () => {

    navigate('/duplicate-request');
    // Add functionality here
  };

  const goBack = () => {
    navigate('/dashboard'); // Navigate to the previous page
  };

  return (
    <>
      <UserProfile />
      <div className="container">
        <div className="containerBox">
          <Grid container spacing={2} justifyContent="center">
            {/* Main Content */}
            <Grid item xs={12} sm={8} md={6}>
              <Box
                sx={{
                  bgcolor: 'rgba(0, 0, 0, 0.5)',
                  borderRadius: 2,
                  padding: '20px',
                  textAlign: 'center',
                }}
              >
                <Typography variant="h4" component="h1" sx={{ color: '#fff' }}>
                  Inbound Automation {selectedBu}
                </Typography>
                <Typography variant="body1" component="p" sx={{ color: '#fff', margin: '20px 0' }}>
                  Send us your Request
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                  <StyledButton type="button" onClick={createNewRequest} size="small">
                    Create a New Request
                  </StyledButton>
                  <StyledButton type="button" onClick={duplicateRequest} size="small">
                    Duplicate an Existing Request
                  </StyledButton>
                </Box>
              </Box>
            </Grid>

            {/* Footer Section */}
            <Grid item xs={12}>
              <Box
                sx={{
                  textAlign: 'center',
                  marginTop: '20px',
                  position: 'fixed',
                  bottom: '20px',
                  width: '100%',
                }}
              >
                <Grid container justifyContent="flex-end">
                  <Grid item>
                    <Button
                      type="button"
                      variant="contained"
                      style={{
                        backgroundColor: '#ffffff',
                        border: 'none',
                        padding: '5px',
                        color: '#0047ba',
                        fontWeight: '600',
                        alignItems: 'center',
                        boxShadow: 'none',
                        minWidth: 'unset',
                        marginTop: '10px',
                        right: '50px',
                      }}
                      onClick={goBack}
                    >
                      Switch BU
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </div >
      </div>
    </>
  );
};

export default InboundAutomation;